export default {
  sortByDateIsoStringProperty(list, dateIsoStringPropertyName) {
    return list.sort((a, b) => {
      let dateTimeA = Date.parse(a[dateIsoStringPropertyName]);
      let dateTimeB = Date.parse(b[dateIsoStringPropertyName]);
      let diff = dateTimeA - dateTimeB;
      return diff < 0 ? -1 : 1;
    });
  },

  dateComparator(a,b){
    let aTime=a.getTime();
    let bTime=b.getTime();

    return aTime-bTime;
  },
  sortByDateIsoStrDescending(a, b) {
    return b.date_ - a.date_;
  }
};
